'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');

function queryGeolocationPermission(onChange) {
    var _a;
    return tslib.__awaiter(this, void 0, void 0, function () {
        var result;
        return tslib.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (typeof ((_a = window.navigator.permissions) === null || _a === void 0 ? void 0 : _a.query) !== 'function') {
                        return [2 /*return*/, showGeolocationPrompt()];
                    }
                    return [4 /*yield*/, window.navigator.permissions.query({
                            name: 'geolocation',
                        })];
                case 1:
                    result = _b.sent();
                    if (onChange) {
                        result.onchange = onChange;
                    }
                    switch (result.state) {
                        case 'granted':
                            return [2 /*return*/, result.state];
                        case 'denied':
                            return [2 /*return*/, result.state];
                        default:
                            return [2 /*return*/, showGeolocationPrompt()];
                    }
            }
        });
    });
}
function showGeolocationPrompt() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    window.navigator.geolocation.getCurrentPosition(function () {
                        resolve('granted');
                    }, function () {
                        resolve('denied');
                    });
                })];
        });
    });
}

exports.queryGeolocationPermission = queryGeolocationPermission;
